import React from "react";
import { Icon } from "@jsq/ds/icons";
import { getLpPortalTermsAndPrivacyPath, getLpPortalTouBasePath } from "common/helpers/url";
import { Link } from "react-router-dom";
import { broadcastLogout } from "common/utils/coordinatedLogout";
import { type dgEventGlobalThis } from "common/utils/o11y/types";
import styles from "./styles.scss";
import { useFeaturesContext } from "../../contexts/FeaturesContext";
import { useAppContext } from "../../AppContext";

const runtimeGlobal = globalThis as dgEventGlobalThis;

type Props = {
  singleManager: boolean;
  userName?: string;
  userEmail?: string;
  arenaDomain?: string;
  onlyOneGp: boolean;
};

export const ProfileDropDown = ({
  singleManager,
  userName,
  userEmail,
  arenaDomain,
  onlyOneGp,
}: Props) => {
  const user = userName && userEmail;
  const { getLpPortalSettingsPath } = useAppContext();

  const onCookieSettingsClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    runtimeGlobal.DG_BANNER_API?.showConsentBanner();
  };

  const { unifiedPortal } = useFeaturesContext();
  const privacyPolicyUrl = unifiedPortal
    ? getLpPortalTermsAndPrivacyPath()
    : getLpPortalTouBasePath();

  return (
    <span data-cy="dropdown-menu">
      {user ? (
        <li className={styles.ProfileDropDown__wrapper}>
          <p className="text-md strong stacked-sm user-name">{userName}</p>
          <p className="text-md stacked-md user-email">{userEmail}</p>
        </li>
      ) : (
        <div className={styles.ProfileDropDown__wrapper} />
      )}

      <div className={styles.ProfileDropDown__linksWrapper}>
        <p>
          <Link
            to={getLpPortalSettingsPath()}
            target={singleManager && !onlyOneGp ? "_blank" : undefined}
            data-cy="global-settings-nav"
            rel="noreferrer"
          >
            Settings
            {singleManager && !onlyOneGp && (
              <>
                <span style={{ width: "10px", display: "inline-block" }} />
                <Icon type="external-link" />
              </>
            )}
          </Link>
        </p>
        <p>
          <a
            onClick={broadcastLogout}
            href={singleManager ? `/logout?arena=${arenaDomain}` : "/logout"}
            data-cy="global-logout"
          >
            Log out
          </a>
        </p>
      </div>
      <hr />

      <div className={styles.ProfileDropDown__termsCopyrightWrapper}>
        <a target="_blank" rel="noopener noreferrer" href={privacyPolicyUrl}>
          <span data-cy="global-terms-and-privacy-nav">Terms and privacy</span>
        </a>
        {" | "}
        <a href="/" onClick={onCookieSettingsClick}>
          Cookie Settings
        </a>
        <p>© {new Date().getFullYear()} Juniper Square, Inc.</p>
      </div>
    </span>
  );
};
